module.exports = __webpack_public_path__ + "/static/assets/770c1f3eca5a0d7c327c275865dad3f0.svg";